import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { leadReportsReducer } from "../../redux/slices/leadReports";
import {
    getConnectionReportsAsync,
    getConnectionSourceMappingAsync,
} from "../../redux/slices/leadReports/leadReports.asyncActions";
import {
    clearConnectionReport,
    clearSourceMapping,
} from "../../redux/slices/leadReports/leadReports.slice";
import LeadConnectionReportsPage from "./LeadConnectionReportsPage.layout";
import {
    LeadConnectionReportsPageDispatchProps,
    LeadConnectionReportsPageStateProps,
} from "./LeadConnectionReportsPage.types";

const mapStateToProps = (state: any): LeadConnectionReportsPageStateProps => ({
    isReportsLoading: state[leadReportsReducer].isReportsLoading,
    connectionReport: state[leadReportsReducer].connectionReport,
    language: state.languagesState.languages,
    sourceMapping: state[leadReportsReducer].sourceMapping,
    isSourceMappingLoading: state[leadReportsReducer].isSourceMappingLoading,
});

const mapDispatchToProps = (
    dispatch: any,
): LeadConnectionReportsPageDispatchProps => ({
    dispatchGetConnectionReports: (params) =>
        dispatch(getConnectionReportsAsync(params)),
    dispatchClearConnectionReports: () => dispatch(clearConnectionReport()),
    dispatchGetConnectionSourceMapping: (params) =>
        dispatch(getConnectionSourceMappingAsync(params)),
    dispatchClearSourceMapping: () => dispatch(clearSourceMapping()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(LeadConnectionReportsPage);
